import React, {useState, useMemo} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import InputSearch from "../../shared/input-search/component";
import debounce from "../../../utils/helpers/debounce";
import Close from "./images/close.svg";

const SearchFilter = ({
    placeholder,
    searchItems,
    searchIconType,
    inputProps = {},
    onCloseCallback = () => {},
    onSearchHandler = () => {},
    searchFocused = false
}) => {
    const [searchKeyword, setSearchKeyword] = useState("");
    // const searchKey = "displayText";

    const debouncedSearch = debounce((value) => {
        const keyWord = value.replace(/\s+/g, "").replace(/-/g, "").toLowerCase();
        const filteredItems = [];
        searchItems.forEach((item) => {
            let filteredOptions = null;
            if (item.subFilter && item.subFilter.options) {
                filteredOptions = item.subFilter.options.filter((option) => {
                    const opt = (item.displayText + option.displayText)
                        .replace(/\s+/g, "")
                        .replace(/-/g, "")
                        .toLowerCase();
                    return opt.includes(keyWord);
                });
            }
            if (filteredOptions && filteredOptions.length > 0) {
                filteredItems.push({
                    ...item,
                    subFilter: {
                        ...item.subFilter,
                        options: [...filteredOptions]
                    }
                });
            }
        });
        onSearchHandler(filteredItems, value);
    // eslint-disable-next-line no-magic-numbers
    }, 100);
    const memoizedDebouncedSearch = useMemo(() => debouncedSearch, [debouncedSearch]);

    const onSearch = (value) => {
        setSearchKeyword(value);
        memoizedDebouncedSearch(value);
    };

    const handleClose = () => {
        setSearchKeyword("");
        onCloseCallback();
    };

    return (
        <div styleName={"styles.searchWrap"}>
            <InputSearch
                onChange={(e) => onSearch(e.target.value)}
                value={searchKeyword}
                placeholder={placeholder}
                searchIconType = {searchIconType}
                {...inputProps}
            />
            {searchFocused && <div styleName={"styles.closeWrappers"} onClick={handleClose}>
                <img src={Close} />
            </div>
            }
        </div>
    );
};

SearchFilter.propTypes = {
    placeholder: PropTypes.string,
    searchItems: PropTypes.array,
    onSearchHandler: PropTypes.func,
    searchIconType: PropTypes.string,
    inputProps: PropTypes.object,
    onCloseCallback: PropTypes.func,
    searchFocused: PropTypes.bool
};

export default SearchFilter;
